/**
 * Route an absolute URL through the reverse proxy's `__ASSET__` passthrough.
 *
 * The proxy strips the `/__ASSET__/` prefix and proxies the request to the
 * wrapped merchant URL, so the browser can reach an otherwise CORS-protected
 * storefront endpoint (e.g. `suggest.json`, `product.js`) via our own origin.
 * Mirrors the `case "asset"` branch of `web/reverse-proxy`'s `proxyURL.ts`.
 *
 * @param url Absolute merchant URL (must include protocol + host).
 */
export function toAssetProxyUrl(url: string): string {
  const proxyBase = new URL(import.meta.env.VITE_REVERSE_PROXY_URL as string);
  return new URL(`/__ASSET__/${url}`, proxyBase).href;
}
